import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper";
import getImagePath from "helpers/get-image-path";
import Link from "components/link";
import { getCalculatedContainer } from "./responsiveHandle";
import {
  basicSlide, basicSlideItem, basicSlideImg, basicSlideTitle,
  basicSlideTag, basicSlideContent, basicSlideSubtitle
} from "./style.mod.scss";

const BasicSlide = ({ data }) => {

  const { title, subtitle, slider, bgColor } = data;
  const [dimensions, setDimensions] = useState(null);

  useEffect(() => {
    const { screenResolution } = getCalculatedContainer();
    var containerWidth = (window.innerWidth - 17);

    setDimensions(
      ((containerWidth - screenResolution) / 2)
    );
  }, []);


  var settings = {
    slidesPerView: 1.5,
    spaceBetween: 35,
    pagination: { clickable: true },
    modules: [Pagination, Mousewheel],
    speed: 700,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 45,
        slidesPerView: 2.5,
      },
      992: {
        spaceBetween: 50,
        slidesPerView: 3,
      },
      1200: {
        pagination: { clickable: true },
        spaceBetween: 65,
        slidesPerView: 3.5,
      }
    }
  };

  return (
    <div style={{
      paddingLeft: dimensions + "px",
      backgroundColor: bgColor && bgColor.hex
    }} className={basicSlide} >
      <div className={basicSlideContent}>
        <span className={basicSlideTag}>{title}</span>
        <h1 className={basicSlideTitle}>{subtitle}</h1>
        <Swiper {...settings}>
          {slider.map((slide) => {
            const { slideImage, _key, slideText = "" } = slide;
            return (
              <SwiperSlide key={_key} className={basicSlideItem}>
                <Link to={slide.slideUrl}>
                  <img src={getImagePath(slideImage)} alt={slideImage?.alt} className={basicSlideImg} />
                </Link>
                <p className={basicSlideSubtitle}>{slideText}</p>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default BasicSlide;